export default "__VITE_ASSET__DIHbiHHA__"